import { CashReceipt } from '@/fragments/orders';

export function CustomerCashReceiptPage() {
  return <CashReceipt />;
}
